import styled from 'styled-components';
import { default as MaterialTextField } from '@mui/material/TextField';

const StyledTextField = styled(MaterialTextField)``;

const TextField = ({ error, ...otherProps }) => <StyledTextField error={error} {...otherProps} />;

export default TextField;
